var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafePregnancy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "#FFE6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 18C34.6 14.8 39.2 14.8 42.4 17.2C45.6 19.6 46.4 24 44 27.2L32 40L20 27.2C17.6 24 18.4 19.6 21.6 17.2C24.8 14.8 29.4 14.8 32 18Z",
    fill: "#FF4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 32C41.2 32 44 34.8 44 38C44 41.2 41.2 44 38 44C34.8 44 32 41.2 32 38C32 34.8 34.8 32 38 32Z",
    fill: "#FF4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 32C29.2 32 32 34.8 32 38C32 41.2 29.2 44 26 44C22.8 44 20 41.2 20 38C20 34.8 22.8 32 26 32Z",
    fill: "#FF4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafePregnancy);
export default __webpack_public_path__ + "static/media/safe-pregnancy.87457e04917790485b1ab023d6f23052.svg";
export { ForwardRef as ReactComponent };